__turbopack_context__.v({
  "disabled": "Textarea-module-scss-module__f-KX5a__disabled",
  "error": "Textarea-module-scss-module__f-KX5a__error",
  "fullWidth": "Textarea-module-scss-module__f-KX5a__fullWidth",
  "hasError": "Textarea-module-scss-module__f-KX5a__hasError",
  "helper": "Textarea-module-scss-module__f-KX5a__helper",
  "label": "Textarea-module-scss-module__f-KX5a__label",
  "messages": "Textarea-module-scss-module__f-KX5a__messages",
  "required": "Textarea-module-scss-module__f-KX5a__required",
  "secondary": "Textarea-module-scss-module__f-KX5a__secondary",
  "textarea": "Textarea-module-scss-module__f-KX5a__textarea",
  "wrapper": "Textarea-module-scss-module__f-KX5a__wrapper",
});
